import React from 'react';
import { KPICard } from '@/components/ui';
import type { ScheduleStats } from '../types/construction-schedules.types';

interface Props {
  stats?: ScheduleStats;
  isLoading?: boolean;
}

export const ScheduleKPIBoard: React.FC<Props> = ({ stats, isLoading }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <KPICard
        title="Đang triển khai"
        value={stats?.activeToday || 0}
        icon="ri-play-circle-line"
        variant="primary"
        isLoading={isLoading}
      />
      <KPICard
        title="Trễ tiến độ"
        value={stats?.delayedCount || 0}
        icon="ri-error-warning-line"
        variant="danger"
        isLoading={isLoading}
      />
      <KPICard
        title="Sắp diễn ra"
        value={stats?.upcomingCount || 0}
        icon="ri-calendar-todo-line"
        variant="info"
        isLoading={isLoading}
      />
      <KPICard
        title="Tỉ lệ đúng hạn"
        value={`${Math.round(stats?.completionRate || 0)}%`}
        icon="ri-checkbox-circle-line"
        variant="success"
        isLoading={isLoading}
      />
    </div>
  );
};
